// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const setEtiquetasPessoaService = async (
  pessoaId: number,
  etiquetaIds: number[]
) => {
  const Token = validateToken();
  if (!Token) return false;

  const URL = `${Globais.DOMINIOBACK}/etiqueta-pessoa/pessoa/${pessoaId}`;

  try {
    const response = await axios.put(
      URL,
      { etiquetaIds },
      { headers: { Authorization: Token.AuthStr } }
    );

    return response?.data ?? false;
  } catch (error) {
    console.error(error);
    return false;
  }
};
